<template>
  <div class="rating-table__wrapper"
    v-bind:class="'rating-table__wrapper-no-yscroll'"
  >
    <h4 v-if="ratingList <= 0">Рейтинг не заполнен</h4>
    <table v-else class="rating-table__table">
      <thead>
        <tr>
          <th>№</th>
          <th>Название</th>
          <th v-for="i in roundQty" v-bind:key="i">
            Раунд {{ i }}
          </th>
          <th class="dark">Умно!</th>
          <th class="dark">Смешно!</th>
          <th>Итого!</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(team, idx) in ratingList" v-bind:key="idx">
          <td>
            <span
              class="medal"
              v-bind:class="{ [team.medal]: showMedal }"
            >
              {{ team.pos }}
            </span>
          </td>
          <td>
            {{ team.team }}
          </td>
          <td v-for="(score, sidx) in team.score" v-bind:key="sidx">
            {{ score }}
          </td>
          <td class="dark">{{ team.totalGeneral }}</td>
          <td class="dark">{{ team.totalLol }}</td>
          <td>{{ team.total }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'RatingTable',

  props: {
    ratingList: Array,
    roundQty: Number,
    perPage: Number,
    currentPage: Number,
    showMedal: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
